const axios = require('axios');

async function getSplashs(condition) {
  try {
    const resData = await axios.get('/api/v1/admin/splash/all', { params: condition });
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function findSplashById(id) {
  try {
    const resData = await axios.get('/api/v1/admin/splash', { params: { id } });
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function updateSplash(params) {
  try {
    const resData = await axios.put('/api/v1/admin/splash', params);
    return resData;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function createSplash(params) {
  try {
    const resData = await axios.post('/api/v1/admin/splash', params);
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

module.exports = { getSplashs, findSplashById, updateSplash, createSplash };
